import React from 'react';
import { Text, Heading, Box, Flex, Image } from 'rebass';
import PlaneConfettiSrc from '@/components/app/plane-confetti.svg';
import videoSrc from '@/components/app/video.svg';

const howItWorksPoints = (detail) => {
  if (detail === 'Video Guestbook')
    return [
      {
        'Design your printables': [
          ' Add your picture or use our stock photo',
          ' Use our default text or edit it to suit your preferences',
          ' Choose a design template from our professionally designed library',
          ' Edit fonts, colours, size',
        ],
      },
      {
        Print: [
          ' Print Tabletop cards you can place on all the tables and in other high traffic parts of the venue',
          ' Print a large poster for a high traffic area like a photo booth',
          ' Export the QR code to give to your printer to add to other items like name cards',
        ],
      },
      {
        ' Guests scan the QR code, record a message and it immediately arrives in your app, safe and sound':
          [],
      },
      {
        ' After the event, drag and drop (or remove) clips on your timeline to create the video': [
          ' Optionally add some extra creative touches, like text, GIFs, stickers, pictures, music, using our easy-to-use tools',
        ],
      },
      {
        ' Once you’re happy with the preview, tap a button to create your HD quality, sharable, merged video':
          [
            ' When the video’s ready, you can leave it online — we continue to host it for a year — or download it to your hard drive. Or both.',
          ],
      },
    ];
  if (detail === 'Classic')
    return [
      {
        'We walk you through creating a great-looking digital invitation': [
          ' Add their picture or use our stock photo',
          ' Use our default text or edit it to suit your preferences',
          ' Select one or more ideas from our idea library to suggest people talk about, or create your own ',
          ' Record a video request (optional) as part of your invitation. This will make it feel extra personal and significantly reduce your need to constantly remind people',
          ' Send your friends and family the link to your digital invitation via email, text or any way you normally connect',
        ],
      },
      {
        'Your friends and family respond': [
          ' Friends and Family simply tap to record a message on any device. No need to download an app or create an account.',
          ' Videos are safely uploaded in full quality to your timeline, ready and waiting for you to view',
        ],
      },
      {
        'Drag and drop the clips to your timeline to create the video': [
          'Optionally add some extra creative touches, like text, GIFs, stickers, pictures, music, using our easy-to-use tools',
        ],
      },
      {
        'Once you’re happy with the preview, complete your purchase, then process the video to get an HD, sharable version':
          [
            ' When the video’s ready, send the link to your loved one, or play it live',
            ' Optionally send the link to your friends who asked to receive it',
          ],
      },
    ];
  if (detail === 'Q&A')
    return [
      {
        'We walk you through creating a great-looking digital invitation': [
          ' Select a template from our library or create your own custom template',
          ' Choose questions from the template or create your own custom questions',
          ' Add a picture or use our stock photo',
          ' Use our default text or edit it to suit your preferences',
          ' Record a video request (optional) as part of your invitation. This will make it feel extra personal and significantly reduce your need to constantly remind people',
          ' Send your friends and family the link to your digital invitation via email, text or any way you normally connect',
        ],
      },
      {
        'Your friends and family respond': [
          ' Each person records a series of answers to your questions.',
          ' Their videos immediately arrive in your app timeline, safe and sound.',
          ' In your timeline, each person’s answers are automatically separated and grouped after each question. So for example, you’ll have Q1, Friend 1, 2, 3 answers then Q2, Friend 1, 2, 3 answers, etc.',
        ],
      },
      {
        'Drag and drop or delete clips as you wish. This is usually not necessary but you have complete flexibility':
          [
            ' Optionally add some extra creative touches, like text, GIFs, stickers, pictures, music, using our easy-to-use tools',
          ],
      },
      {
        'Once you’re happy with the preview, complete your purchase, then process the video to get an HD, sharable version':
          [
            ' When the video’s ready, send the link to whoever you choose, or play it live',
            ' Optionally send the link to your friends who asked to receive it',
          ],
      },
    ];

  return [];
};

export const templateDetails = (detail, heading) => {
  if (detail === 'Video Guestbook' && heading === 'subHeading')
    return (
      <>
        This is perfect for <u>at-the-event</u> video messages. Capture the mood and atmosphere of
        your event through your friends&apos; eyes!
      </>
    );

  if (heading === 'description') {
    if (detail === 'Video Guestbook')
      return (
        <Text
          className="dm-sans"
          color="greys.10"
          lineHeight="20px"
          fontSize="16px"
          fontWeight={400}
          pt={2}
        >
          With this style, you print professionally designed Printables, each containing your
          personalized QR code, and place them on tables and other high traffic areas.
          <br />
          <br />
          Your guests scan your QR code and tap Record. No need for an account. Their videos are
          quickly uploaded in full quality to your account, where they remain safe and sound,
          waiting for your final touch.
          <br />
          <br />
          Once ready, you can quickly merge them all into a single video, or drag and drop to
          rearrange. You can also add other creative touches with our easy-to-use Editing Suite.
          <br />
          <br />
          Your friends will help you create a precious keepsake you&apos;ll treasure for the rest of
          your life!
          <br />
          <br />
          <b>
            {' '}
            We walk you through creating great-looking Printables for your event. All printables
            have a QR code.
          </b>
        </Text>
      );
    if (detail === 'Classic')
      return (
        <Text
          className="dm-sans"
          color="greys.10"
          lineHeight="20px"
          fontSize="16px"
          fontWeight={400}
          pt={2}
        >
          <b>
            {' '}
            Ideal for celebrating birthdays, weddings, anniversaries, retirements and other
            occasions with friends and family who can’t be with you.
          </b>
        </Text>
      );
    if (detail === 'Q&A')
      return (
        <Text
          className="dm-sans"
          color="greys.10"
          lineHeight="20px"
          fontSize="16px"
          fontWeight={400}
          pt={2}
        >
          Each person is sent a link with a series of questions. They respond by video, one question
          at a time, until complete. Everyone’s responses are later merged into a single video,
          automatically sorted by question.
          <br />
          <br />
          The main difference vs our Classic style is in step 2 below.
          <br />
          <br />
          <b>
            Ideal for use as a game for bridal showers (eg Newlywed Game), Baby showers, etc. Also
            many other creative uses.
          </b>
        </Text>
      );
  }
  if (heading === 'howItWorks') {
    return (
      <Box pt={3}>
        <Heading
          className="dm-sans"
          color="greys.9"
          lineHeight="32px"
          fontSize="24px"
          textAlign="left"
          fontWeight={700}
          mb={2}
        >
          Here’s how it works
        </Heading>
        {howItWorksPoints(detail).map((det) => (
          <Flex key={det}>
            <Box
              sx={{
                borderLeft: '2px dashed #ED2365',
                mr: '-15px',
                mt: '5px',
              }}
            />
            <Image src={PlaneConfettiSrc} height="30px" width="30px" sx={{ minWidth: '30px' }} />
            <Box
              sx={{
                width: '100%',
                p: 3,
                ml: 3,
                border: '1px solid #ECEBEA',
                borderRadius: '8px',
                mb: 2,
              }}
            >
              {Object.keys(det).map((question, index) => (
                <Box key={question}>
                  <Text
                    className="dm-sans"
                    fontWeight={500}
                    fontSize="16px"
                    lineHeight="24px"
                    mb={1}
                  >
                    <span style={{ color: '#626DF0' }}>{index + 1}.</span>&nbsp;{question}
                  </Text>
                  <Box pl={3}>
                    <ul>
                      {det[question].map((quest) => (
                        <li
                          style={{
                            listStyle: 'initial',
                            color: '#626DF0',
                          }}
                          key={quest}
                        >
                          <Text
                            className="dm-sans"
                            fontWeight={400}
                            fontSize="16px"
                            lineHeight="20px"
                            color="greys.10"
                          >
                            {quest}
                          </Text>
                        </li>
                      ))}
                    </ul>
                  </Box>
                </Box>
              ))}
            </Box>
          </Flex>
        ))}
      </Box>
    );
  }

  return null;
};

function LearnMoreSection({ isOpen }) {
  return (
    <>
      <Heading color="greys.9" lineHeight="32px" fontSize="32px" textAlign="left" fontWeight={700}>
        {isOpen}
      </Heading>
      {templateDetails(isOpen, 'subHeading') && (
        <Text color="pinks.4" fontSize="18px" lineHeight="26px" pt={1}>
          {templateDetails(isOpen, 'subHeading')}
        </Text>
      )}

      {templateDetails(isOpen, 'description')}
      {templateDetails(isOpen, 'howItWorks')}
      <Flex mb={2} alignItems="center">
        <Image src={videoSrc} height="24px" width="24px" ml="-12px" />
        <Heading
          color="greys.9"
          lineHeight="32px"
          fontSize="24px"
          textAlign="left"
          fontWeight={700}
          ml={3}
        >
          Enjoy it forever!
        </Heading>
      </Flex>
    </>
  );
}

export default LearnMoreSection;
